import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { isNotEmpty } from '../../../utils/isBlank';

@Component({
  selector: 'date-time-picker',
  templateUrl: 'date-time-picker.component.html',
  standalone: true,
  styleUrls: ['date-time-picker.component.scss'],
  imports: [FormsModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateTimePickerComponent implements OnInit {
  @Input() defaultValue: string;
  @Input() label: string;
  @Input() max: string = '';
  @Input() min: string = '';
  @Output() valueChange: EventEmitter<Date | null> = new EventEmitter<Date>();
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false;

  dateTime: string | null = null;

  get hasError(): boolean {
    return this.isRequired && !this.dateTime;
  }

  constructor() {}

  ngOnInit(): void {
    if (this.defaultValue) {
      this.dateTime = moment(this.defaultValue).format('YYYY-MM-DDTHH:mm');
    }
  }

  onDateTimeChange($event: string | null): void {
    this.dateTime = $event;
    if (isNotEmpty(this.dateTime)) {
      this.valueChange.emit(new Date(this.dateTime));
    } else {
      this.valueChange.emit(null);
    }
  }
}
